/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { AodRule } from "./AodRule";
import type { AodRunStatusData } from "./AodRunStatusData";
import type { PublicJobDto } from "./PublicJobDto";

export const AodRunTypeEnum = {
    EOW: "EOW",
    ORDER_END: "ORDER_END",
    MANUAL: "MANUAL"
} as const;

export type AodRunTypeEnumKey = (typeof AodRunTypeEnum)[keyof typeof AodRunTypeEnum];

export const AodRunStatusEnum = {
    WAITING: "WAITING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED_WITH_EXPORT: "COMPLETED_WITH_EXPORT",
    COMPLETED_WITHOUT_EXPORT: "COMPLETED_WITHOUT_EXPORT",
    WAITING_FOR_REPROCESS: "WAITING_FOR_REPROCESS",
    FAILED: "FAILED"
} as const;

export type AodRunStatusEnumKey = (typeof AodRunStatusEnum)[keyof typeof AodRunStatusEnum];

export const AodRunUserStatusEnum = {
    ACCEPTED: "ACCEPTED",
    REFRESHED: "REFRESHED",
    REPROCESSED: "REPROCESSED"
} as const;

export type AodRunUserStatusEnumKey = (typeof AodRunUserStatusEnum)[keyof typeof AodRunUserStatusEnum];

export type AodRun = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type object
    */
    rule: AodRule;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined, date-time
    */
    scheduledDatetime?: string;
    /**
     * @deprecated
     * @type string | undefined, date-time
    */
    datetime?: string;
    /**
     * @type string
    */
    type: AodRunTypeEnumKey;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string
    */
    jobId: string;
    /**
     * @type string | undefined
    */
    reprocessJobId?: string;
    /**
     * @type string
    */
    status: AodRunStatusEnumKey;
    /**
     * @type object | undefined
    */
    statusData?: AodRunStatusData;
    /**
     * @type string
    */
    userStatus: AodRunUserStatusEnumKey;
    /**
     * @deprecated
     * @type object
    */
    userStatusData: {
        /**
         * @type string | undefined, date-time
        */
        updatedAt?: string;
        /**
         * @type string | undefined
        */
        userId?: string;
    } | null;
    /**
     * @type string | undefined
    */
    reportId?: string;
    /**
     * @type object | undefined
    */
    overrideReportConfig?: object;
    /**
     * @type object | undefined
    */
    overrideExportConditions?: object;
    /**
     * @type string
    */
    order: string;
    /**
     * @type string | undefined
    */
    interval?: string;
    /**
     * @type string | undefined
    */
    snapshotHash?: string;
    /**
     * @description Number of times this run was executed (processed by ProcessAodRunJob).
     * @type number
    */
    executionCount: number;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type boolean
    */
    canRestart: boolean;
    /**
     * @type boolean
    */
    canRefresh: boolean;
    /**
     * @type boolean
    */
    canAccept: boolean;
    /**
     * @type boolean
    */
    canReprocess: boolean;
    /**
     * @type boolean
    */
    isPending: boolean;
    /**
     * @type boolean
    */
    isCompleted: boolean;
    /**
     * @type boolean
    */
    isFailed: boolean;
    /**
     * @type boolean
    */
    isRefreshing: boolean;
    /**
     * @type boolean
    */
    isAccepting: boolean;
    /**
     * @type boolean
    */
    isReprocessStarted: boolean;
    /**
     * @type boolean
    */
    isReprocessCompleted: boolean;
    /**
     * @type boolean
    */
    isReprocessFailed: boolean;
    /**
     * @type number | undefined
    */
    efficiency?: number;
    processJobStatus: PublicJobDto | null;
    reprocessJobStatus: PublicJobDto | null;
};